import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArticleComponent } from './article.component';
import { ArticleDetailComponent } from '../article-detail/article-detail.component';
import { LoginGuard } from '../login/login.guard'

const routes: Routes = [
  {
    path: 'article',
    component: ArticleComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'article/new',
    component: ArticleDetailComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'article/:id',
    component: ArticleDetailComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArticleRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article/article-routing.module.ts